module.exports = __webpack_public_path__ + "img/Tips.5869cf9b.png";